import React from "react";
import classes from "./Header.module.css";

import AppBar from "@material-ui/core/AppBar";
import { Typography, Toolbar, IconButton } from "@material-ui/core";

import * as ImageURL from "../../assets/Resources/ImagesURL.json";

import { connect } from "react-redux";

const Header = (props) => {
  return (
    <div className={classes.Header}>
      <AppBar position="relative" color="inherit" style={{ boxShadow: "none" }}>
        <Toolbar>
          <Typography variant="h3">{props.name}</Typography>
          <IconButton
            edge="end"
            size="medium"
            style={{ position: "absolute", right: "50px" }}
          >
            <img src={ImageURL.User.URL} alt={ImageURL.User.alt} />
          </IconButton>
        </Toolbar>
      </AppBar>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    name: state.actRed.name,
  };
};

export default connect(mapStateToProps)(Header);
